module.exports = __webpack_public_path__ + "img/bg-game.a49ab37e.png";